import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertService } from '../alert/alert.service';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
    apiUrl: string = environment.CONNECT_API_URL;
    checkingSettings: boolean = false;
    shownUpdateWarning: boolean = false;
    iOSAPIKey: string;
    androidAPIKey: string;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    public translate: TranslateService
  ) { }
  
  getAppSettings(): Observable<[string]> {
    if (!this.checkingSettings) {
        const url = environment.CONNECT_API_URL + `appSettings`;
        this.checkingSettings = true;
        return this.http.get(url).pipe(
        map((data: any) => {
            if (data.is_app_legacy && !this.shownUpdateWarning) {
              this.alertService.warningAlert(this.translate.instant("ACCOUNT.updateAppVersion"));
              this.shownUpdateWarning = true;
            }
            this.apiUrl = data.api_url;
            this.checkingSettings = false;
            this.iOSAPIKey = data.ios_rc_public_api_key;
            this.androidAPIKey = data.android_rc_public_api_key;
            return [this.apiUrl];
        })
        );
    } else {
        return of([this.apiUrl]);
    }
  }
}
